<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Drivers">
      <button class="btn btn-secondary" @click="syncDrivers" v-submitting="submitting">
        Sync Drivers
      </button>

      <div slot="subheader" class="mt-4 sm:mt-0">
        <NavTabs 
          :tabs="[
            { name: 'Drivers', route: { name: 'DriverList' } },
            { name: 'Driver Groups', route: { name: 'DriverGroups' } },
          ]" 
        />
      </div>
    </PageHeader>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="drivers.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            No drivers have been sync'd from WEBFLEET yet.
          </p> 
          <button class="btn btn-secondary" @click="syncDrivers" v-submitting="submitting">
            Sync Drivers from WEBFLEET
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="drivers.data" 
            :keys="[
              { name: 'Name', slug: 'name', class: 'font-bold' },
              { name: 'Number', slug: 'driverno' },
              { name: 'Cellphone', slug: 'telmobile' }
            ]" />
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="drivers.meta.total" :per-page="drivers.meta.per_page" :current-page="drivers.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DriverList',

  metaInfo: {
    title: 'Drivers'
  },

  async created () {
    await this.getDrivers()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      drivers: {},
      loading: true,
      submitting: false
    }
  },

  methods: {
    async getDrivers () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/drivers`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.drivers = data.drivers
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },
    
    async syncDrivers () {
      try {
        this.submitting = true
        await this.$api.get(`account/${this.$route.params.account}/sync/drivers`)
        this.getDrivers()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getDrivers()
      },
      deep: true
    }
  }
}
</script>